module.exports = __webpack_public_path__ + "static/img/wapIcon_03.b199f3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/wapIcon_03.jpg
// module id = Oo6q
// module chunks = 3